import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=0fe84a05&scoped=true&"
import script from "./TemplateEdit.vue?vue&type=script&lang=js&"
export * from "./TemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=0fe84a05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe84a05",
  null
  
)

export default component.exports